module.exports = __webpack_public_path__ + "img/Add img Icon.518d55e8.svg";